"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sorting = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Sorting component
 *
 * State: Candidate for component extraction when it will be reused in design.
 *
 * @param options
 * @param onChange
 * @constructor
 */ const Sorting = (param)=>{
    let { value, options, onChange } = param;
    const ref = (0, _react.useRef)(null);
    const { getTestId } = (0, _testidGenerator.default)();
    const { onClose, onToggle, open } = (0, _presentationHooks.useDisclose)();
    const displayText = (0, _react.useMemo)(()=>{
        var _options_find;
        return (_options_find = options.find((option)=>option.key === value)) === null || _options_find === void 0 ? void 0 : _options_find.label;
    }, [
        options,
        value
    ]);
    const onButtonClick = (0, _react.useCallback)((event)=>{
        event.stopPropagation();
        onToggle();
    }, [
        onToggle
    ]);
    (0, _presentationHooks.useListenToKeyDown)([
        'Escape'
    ], ()=>{
        onClose();
    });
    const onClick = (0, _react.useCallback)((orderBy)=>async ()=>{
            onClose();
            await onChange(orderBy);
        }, [
        onChange,
        onClose
    ]);
    if (options.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.SortButton, {
                ref: ref,
                "data-testid": getTestId(_constants.SORTING),
                onClick: onButtonClick,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.Sort, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                        fontWeight: "bold",
                        color: "textPrimary",
                        textTransform: "uppercase",
                        children: displayText
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.ClickAwayListener, {
                onClickAway: onClose,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.SortMenu, {
                    "data-testid": getTestId(_constants.SORTING_MENU),
                    open: open,
                    anchorEl: ref.current,
                    placement: "bottom-end",
                    children: options.map((option)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.SortItem, {
                            value: option.key,
                            onClick: onClick(option.key),
                            children: option.label
                        }, option.key))
                })
            })
        ]
    });
};
exports.Sorting = Sorting;
